export const environment = {
  production: false,
  apiBaseUrl:
    'https://homolog-mobile-agenda-edu-api.atlasedu.com.br/gestaoeleva/',
  diasMaximoAtraso: 30,
  EnablePixForAllColigada: false,
  EnablePixForColigada: [
    {
      id: 26,
      filiais: [5]
    },
    {
      id: 42,
      filiais: [1]
    },
  ],
};
